import PdfIcon from '@mui/icons-material/PictureAsPdf'
import { IconButton } from '@mui/material'
import { MemberMessage } from '../../../../../utils/classes/graphql'
import { MemberMessageTabContentWrapper } from '../../../components'

interface LettersTabContentProps {
  item: MemberMessage
}

export const LettersTabContent = ({ item }: LettersTabContentProps) => {
  const fetchPdf = () => {
    // TODO: fetch pdf here!!!!
    // const {viestiId}=item
  }

  return (
    <MemberMessageTabContentWrapper message={item}>
      <IconButton
        edge="start"
        color="inherit"
        aria-label="download"
        onClick={fetchPdf}
        size="large"
      >
        <PdfIcon color="inherit" />
      </IconButton>
    </MemberMessageTabContentWrapper>
  )
}
